module.exports = /* @ngInject */ (_, TranslationService) => {
    return {
        errorCodeToSlugMap: {
            'INVALID_POSTAL_CODE': 'account_form-error-postal-code-region-mismatch'
        },
        getFieldErrors(err) {
            return _.get(err, 'entity.field_errors', []);
        },
        getErrorMessages(scopedErrors, err = {}) {
            const fieldErrors = this.getFieldErrors(err);

            if (fieldErrors.length > 0) {
                fieldErrors.forEach((error) => {
                    const slug = this.errorCodeToSlugMap[error.code];
                    if (slug) {
                        TranslationService.getTranslation(slug, 'chromeLocalization')
                        .then((value) => {
                            if (!scopedErrors[error.code]) {
                                scopedErrors[error.code] = value;
                            }
                        });
                    }
                });
            }
        },
        containsFieldErrors(err) {
            const fieldErrors = this.getFieldErrors(err);
            return fieldErrors.length > 0;
        },
        determineErrors(errors, err = {}) {
            if (_.isObject(err) && err.meta && err.meta.message) {
                errors['meta-message'] = err.meta.message;
            } else if (this.containsFieldErrors(err)) {
                this.getErrorMessages(errors, err);
            } else {
                errors['default-error'] = 'There was a problem creating your registry. Please try again later.';
            }
        }
    };
};
